"use client";

import ShareIcon from "@heroicons/react/24/outline/ShareIcon";
import { useState } from "react";
import dynamic from "next/dynamic";

const SharePageModal = dynamic(
  () => import("@/components/views/modals/SharePageModal"),
);

export default function ShareButton({ id }: { id: number }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <button
        role="button"
        className="flex flex-col gap-1 items-center text-[13.5px] font-medium text-black"
        style={{ fontFamily: "'Inter', sans-serif" }}
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        <ShareIcon className="size-5" />
        Paylaş
      </button>

      <SharePageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
